import { render } from "./BlogTags.vue?vue&type=template&id=c1479c76&scoped=true"
import script from "./BlogTags.vue?vue&type=script&lang=js"
export * from "./BlogTags.vue?vue&type=script&lang=js"

import "./BlogTags.vue?vue&type=style&index=0&id=c1479c76&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1479c76"]])

export default __exports__